import { ReactNode } from "react";

import { DataEventProps } from "@/libraries/wpl/foundations/src";

export type ContentCellData =
    | CellTextContentData
    | CellCheckContentData
    | CellExpanderContentData
    | CellHyperlinkContentData
    | CellRenderContentData
    | null;

export type TextContent = {
    type: "plaintext" | "richtext";
    value: string;
};

export interface CellCheckContentData {
    type: "check";
}

export interface CellTextContentData {
    type: "text";
    value: TextContent;
    check?: boolean;
    lozenge?: string;
}

export interface CellExpanderContentData {
    type: "expander";
    label: string;
    body: TextContent;
    lozenge?: string;
}

export interface CellHyperlinkContentData {
    type: "hyperlink";
    label: string;
    href: string;
    dataEventProps?: DataEventProps;
}

export interface CellRenderContentData {
    type: "render";
    render: () => ReactNode;
}
